import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/vendors/settings/vendor_partners/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings/vendor_partners';

const VendorPartnerSetting: NextPage = () => (
  <>
    <NskHead title="設定" />
    <Component />
  </>
);

export default VendorPartnerSetting;
